<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-DianZanZuiXin1`]" width="1em" height="1em" v-bind="$attrs"><path d="M4.74918 1.80078C2.55479 1.80078 0.775879 3.5797 0.775879 5.77408C0.775879 9.74738 5.47159 13.3595 8.00006 14.1997C10.5285 13.3595 15.2242 9.74738 15.2242 5.77408C15.2242 3.5797 13.4453 1.80078 11.2509 1.80078C9.90713 1.80078 8.71911 2.4679 8.00006 3.489C7.281 2.4679 6.09298 1.80078 4.74918 1.80078Z" :fill="useCurrentColor ? 'currentColor' : '#FD5E5A'"/></svg>
</template>
<script>

export default {
  name: 'IconDianZanZuiXin1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
